import { createSlice } from '@reduxjs/toolkit';
import { getDownloadOrderDetails } from './api';

interface InitialState {
  isLoading: boolean;
  error: string | null;
}

const initialState: InitialState = {
  isLoading: false,
  error: null,
};

const downloadOrderDetailsSlice = createSlice({
  name: 'downloadOrderDetails',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDownloadOrderDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDownloadOrderDetails.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getDownloadOrderDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to download order details';
      });
  },
});

export const { clearError } = downloadOrderDetailsSlice.actions;
export default downloadOrderDetailsSlice.reducer;
